module.exports = __webpack_public_path__ + "static/media/ChristianityExplored.b60985e5.jpg";